import { FilterType } from 'src/app/components/lib/wizard/filters';

import { FILTER_RESOURCES } from './constants';

import type { FilterResourceType } from './filter';
import type { Filters } from '../state/requirements';
import type { DiscountProduct } from 'src/app/queries/discounts/get-discount-products';

export type FilterProductsArg = {
  filters: Filters;
  products: DiscountProduct[] | undefined;
};

type KeysMatchingType<T, U> = keyof {
  [Key in keyof T as keyof Pick<T, T[Key] extends U ? Key : never>]: T[Key];
};

type DiscountProductNumberKeys = KeysMatchingType<DiscountProduct, number | null>;

type DiscountProductNumberArrayKeys = KeysMatchingType<DiscountProduct, number[] | null>;

type OneToOneFilterDefinition = {
  filterKey: FilterResourceType;
  productKey: DiscountProductNumberKeys;
};

type OneToManyFilterDefinition = {
  filterKey: FilterResourceType;
  productKey: DiscountProductNumberArrayKeys;
};

const oneToOneFilters: OneToOneFilterDefinition[] = [
  {
    filterKey: FILTER_RESOURCES.Strain,
    productKey: 'StrainId',
  },
  {
    filterKey: FILTER_RESOURCES.Weight,
    productKey: 'Weight',
  },
  {
    filterKey: FILTER_RESOURCES.Category,
    productKey: 'CategoryId',
  },
  {
    filterKey: FILTER_RESOURCES['Pricing tier'],
    productKey: 'ChargeCodeId',
  },
  {
    filterKey: FILTER_RESOURCES.Brand,
    productKey: 'BrandId',
  },
  {
    filterKey: FILTER_RESOURCES.Vendor,
    productKey: 'VendorId',
  },
  {
    filterKey: FILTER_RESOURCES.Product,
    productKey: 'ProductId',
  },
];

const oneToManyFilters: OneToManyFilterDefinition[] = [
  {
    filterKey: FILTER_RESOURCES['Product tag'],
    productKey: 'TagIds',
  },
  {
    filterKey: FILTER_RESOURCES['Inventory tag'],
    productKey: 'InventoryTagIds',
  },
];

export function filterProducts({ filters, products }: FilterProductsArg) {
  return (products ?? []).filter((product) => {
    for (const { filterKey, productKey } of oneToOneFilters) {
      const filter = filters[filterKey];

      const match = filter.resources.some((resource) => resource.resourceId === product[productKey]);

      if (filter.selectionType === FilterType.INCLUSIONARY && !match) {
        return false;
      }
      if (filter.selectionType === FilterType.EXCLUSIONARY && match) {
        return false;
      }
    }

    for (const { filterKey, productKey } of oneToManyFilters) {
      const filter = filters[filterKey];

      const match = filter.resources.some((resource) => product[productKey]?.find((id) => id === resource.resourceId));

      if (filter.selectionType === FilterType.INCLUSIONARY && !match) {
        return false;
      }
      if (filter.selectionType === FilterType.EXCLUSIONARY && match) {
        return false;
      }
    }

    return true;
  });
}
